// extracted by mini-css-extract-plugin
export var mainBtn = "screen1sub-module--main-btn--8b339";
export var screen1 = "screen1sub-module--screen1--e9364";
export var screen1__date = "screen1sub-module--screen1__date--3e9df";
export var screen1__desc = "screen1sub-module--screen1__desc--c8ef1";
export var screen1__img = "screen1sub-module--screen1__img--664e6";
export var screen1__info = "screen1sub-module--screen1__info--d9454";
export var screen1__prices = "screen1sub-module--screen1__prices--44b30";
export var screen1__pricesNew = "screen1sub-module--screen1__prices--new--2cfad";
export var screen1__pricesOld = "screen1sub-module--screen1__prices--old--a99b0";
export var screen1__pricesProfit = "screen1sub-module--screen1__prices--profit--82e5e";
export var screen1__title = "screen1sub-module--screen1__title--a0408";
export var screen1__wrapper = "screen1sub-module--screen1__wrapper--1adc9";